import React from 'react';
import RenderError from '../../components/RenderError';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  equipmentType,
  formData,
  setFormData,
  errors
}) {
  return (
    <>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="numberOfBarns">
          Number of barns you intend to treat{' '}
        </label>
        <input
          type="number"
          name="numberOfBarns"
          step="1"
          value={formData[unit].numberOfBarns}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].numberOfBarns} />
        )}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="numberOfTreatmentsPerYear">
          Number of treatments per year{' '}
        </label>
        <input
          type="number"
          name="numberOfTreatmentsPerYear"
          step="1"
          value={formData[unit].numberOfTreatmentsPerYear}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].numberOfTreatmentsPerYear} />
        )}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
